import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-of-use',
  imports: [],
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss'
})
export class TermsOfUseComponent {
router: any;
nav(url: string) {
  this.router.navigateByUrl(url);
  window.scrollTo(0,0);
}
}
